import { useContext } from "react"
import { Context } from "..";
import { Route, Routes } from "react-router-dom";
import { privateRoutes, publicRoutes } from "../router";
import { observer } from "mobx-react-lite";

const AppRouter = () => {
    const { store } = useContext(Context);

    return (
        <Routes>
            {!store.isLoading && store.isAuth
                ? privateRoutes.map(route => <Route key={route.path} path={route.path} element={route.component} exact={route.exact}/>)
                : publicRoutes.map(route => <Route key={route.path} path={route.path} element={route.component} exact={route.exact}/> )
            }
        </Routes>
    )
}

export default observer(AppRouter);